export default __webpack_public_path__ + "static/media/m_use_action_cz.9b5ebf8b.png";